import { APP_TYPE } from 'shared/config'
import { GlobalLightEvents } from 'entities/WebSocket/ui/GlobalLightEvents'

export const CommonLightLayout = () => {
  const isVueApp = APP_TYPE === 'vue'

  return <>{!isVueApp && <GlobalLightEvents />}</>
}
